import { useState, useEffect, useRef } from "react";
import img2 from '../Assets/Link → trend2.png.png';

const GallerySlider = ({ Destination }) => {
    const gallery = Destination?.Gallary?.length ? Destination.Gallary : [img2, img2, img2];
    const imagesPerPage = 3;
    const sliderRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(imagesPerPage);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.scrollLeft = currentIndex * 310;
        }
    }, [currentIndex]);

    const nextSlide = () => {
        setCurrentIndex((prev) => prev + 1);
        if (currentIndex >= gallery.length + imagesPerPage - 1) {
            setTimeout(() => {
                setCurrentIndex(imagesPerPage);
                if (sliderRef.current) {
                    sliderRef.current.scrollLeft = imagesPerPage * 310;
                }
            }, 300);
        }
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => prev - 1);
        if (currentIndex <= 0) {
            setTimeout(() => {
                setCurrentIndex(gallery.length);
                if (sliderRef.current) {
                    sliderRef.current.scrollLeft = gallery.length * 310;
                }
            }, 300);
        }
    };

    return (
        <div className="gallery-slider-container">
            <button className="prev-button" onClick={prevSlide}>&#10094;</button>

            <div className="gallery-slider" ref={sliderRef}>
                {[...gallery, ...gallery].map((image, index) => (
                    <img
                        key={index}
                        src={image || img2}
                        alt={`Gallery Image ${index + 1}`}
                        onClick={() => setSelectedImage(image)}
                    />
                ))}
            </div>

            <button className="next-button" onClick={nextSlide}>&#10095;</button>

            {selectedImage && (
                <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="close-button" onClick={() => setSelectedImage(null)}>&times;</span>
                        <img src={selectedImage} alt="Large Preview" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GallerySlider;
